"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/common-components/lib/video.ts
function genVideoLink({
  service,
  id,
  extraParams = "",
  resourceOrigin = "https://frontend.vh.yandex.ru"
}) {
  if (service === "rutube") {
    return `https://rutube.ru/play/embed/${id}${extraParams}`;
  }
  if (service === "youtube") {
    return `https://www.youtube.com/embed/${id}${extraParams}`;
  }
  if (service === "resource") {
    return `${resourceOrigin}/player/${id}?autoplay=0${extraParams}`;
  }
  if (["efir", "vh"].includes(service)) {
    return `https://frontend.vh.yandex.ru/player/${id}?autoplay=0${extraParams}`;
  }
}



exports.genVideoLink = genVideoLink;
//# sourceMappingURL=chunk-XBVQMQCL.js.map